

import { PLCcollectSettingType } from '../CollectSetting/CollectSettingDefine';
import { SpeedKind, MeasureHighKind, MeasureCalcKind } from "../../../../Constant";
import { JudgeSettingSelectType } from "../../../../function/JudgeSettingSelectModel";
import { IsConanAirPlc } from "../../../../function/PlcNoModel";

export type JudgeSettingItem = {
  /** PLC No */
  PLC_NO: number;
  /** AI Card */
  AI_CARD: number;
  /** AI Ch */
  AI_CH: number;
  /** 判定番号 */
  JDG_NO: number;
  /** 使用 */
  USE_ON: number;
  /** 診断タイプ */
  JDG_TYP: number;
  /** 周波数 */
  FREQ_C: number;
  /** 演算方法 */
  CLC_TYP: number;
  /** 演算種別ID */
  MCLC_TYP_ID: number;
  /** 閾値 軽故障 */
  WRN_LIM: number;
  /** 閾値 重故障 */
  ALM_LIM: number;
  /** 裕度 */
  BAND_VAL: number;
  /** 補正 */
  ADJ_ROT_ON: number;
  /** 異常種別 */
  ALM_TYP_NO: number;

  /** 高調波判定実行 */
  HRM_JDG_ON: number;
  /** EMC-B ワード位置 */
  EMC_W_POS: number;
  /** EMC-B DIビット位置 */
  EMC_B_POS: number;
  /** 0：有効，1：無効 有効時，判定値設定画面の全項目が変更可能。*/
  CHANGE_INVALID: number;
  /** 0: 無効, 1:有効*/
  F2_CANCEL: number;
};

export type JudgeSettingSaveModel = {
  JudgeSettingItems: JudgeSettingItem[];
  /** 異常内容チェックフラグ　false:チェックを実施,true:チェックを無視 */
  isAlmTypNoCheck: boolean;
};



/**
 * 演算種別マスタ
 */
export type MST_CLC_TYPE = {
  /**
   * 演算種別ID
   */
  MCLC_TYP_ID: number;
  /**
   * 演算名称
   */
  MCLC_TYP_NAME: string;
  /**
   * 表示順
   */
  SORT_NO: number;
  /**
   * ユニット識別
   */
  SPEED: number;
}

export type JudgeAutoSettingItem = {
  KindNameNo: number;
  KindName: number;
  JogTypeNo: number;
  JogTypeName: number;
  ClcTypeNo: number;
  ClcTypeName: number;
  WrnLim: number;
  AlmLim: number;
  AlmKindTypeNo: number;
  AlmKindName: number;
  RatedSpeedUseFlg: number;
  RatedSpeed: number;
};

/** レスポンス情報 */
export type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};

/** エラーレスポンス詳細 */
export type JudgeSettingErrorData = {
  Min: number;
  Max: number;
  ErrorItem: JudgeSettingItem;
}

/**
 * 判定値設定画面 APIレスポンス
 */
export type JudgeSettingItemModel = {
  UpdCnt: number;
  JdgSetItems: JudgeSettingItem[];
  ResponceData: ResponceDataType;
  JdgSetErrData: JudgeSettingErrorData;
};

/**
 * 判定値設定画面 選択肢
 */
export type JudgeSettingParameter = {
  /** 診断タイプ 選択肢 */
  JudgeTypes: ComboItem[];
  /** 演算方法 選択肢 */
  CLCTypes: ComboItem[];
  /** 異常種別 選択肢 */
  AlarmKinds: ComboItem[];
  /**演算方法種別 */
  MClcTypes: ComboItem[];
};
export type ComboItem = {
  Key: number;
  Disp: string;
  Tag?: any; // 付加情報
}

export const GetJudgeSettingItems = (plcNo: number, aiNo: number, chNo: number): Promise<JudgeSettingItem[]> => {

  const url = `api/JudgeSetting/Items/${plcNo}/${aiNo}/${chNo}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: JudgeSettingItem[]) => {
        if (JudgeSettingValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
const JudgeSettingValidate = (data: JudgeSettingItem[]) => {
  //LogD(`JudgeSetting ckeck ${data}`,true);
  if (data == undefined) return false;
  //LogD("JudgeSetting ckeck ok",true);
  return true;
};

export const GetJudgeAutoSettingItems = ()
  : Promise<{ JudgeAutoSettingList: JudgeAutoSettingItem[], ResponceDataModel: ResponceDataType }> => {
  const url = `api/JudgeSetting/AutoSetting/`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: { JudgeAutoSettingList: JudgeAutoSettingItem[], ResponceDataModel: ResponceDataType }) => {
        resolve(result);
      }).catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};


/**
 * 設定保存
*/
export const SetJudgeSettingItems = (items: JudgeSettingItem[]): Promise<JudgeSettingItemModel> => {
  const param: JudgeSettingSaveModel = { JudgeSettingItems: items, isAlmTypNoCheck: false };
  console.debug(['SetJudgeSettingItems()', param]);

  return new Promise((resolve, reject) => {
    fetch("api/JudgeSetting/Items", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((result: JudgeSettingItemModel) => {
        //console.debug(['result', result]);
        if (SetJudgeSettingValidate(result)) resolve(result);
        reject('Invalidate response');
      })
      .catch(reason => reject(reason));
  });
}


const SetJudgeSettingValidate = (data: JudgeSettingItemModel) => {
  if (data == undefined) return false;
  return true;
};

export const GetJudgeSettingParameter = (): Promise<JudgeSettingParameter> => {

  const url = 'api/JudgeSetting/Parameter';
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: JudgeSettingParameter) => {
        resolve(result);
      })
      .catch(reason => reject(reason));
  });
};


/**
 * 軸受特徴周波数自動設定　一覧取得
 * @param plcNo
 * @param aiNo
 * @param chNo
 * @returns
 */
export const GethandleBearingFeaturesFreqItems = (plcNo: number, aiNo: number, chNo: number, itemNameNo: number): Promise<JudgeSettingItemModel> => {
  const url = `api/JudgeSetting/bearingFeaturesFreqItems/${plcNo}/${aiNo}/${chNo}/${itemNameNo}`;
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: JudgeSettingItemModel) => {
        if (GethandleBearingFeaturesFreqValidate(result)) {
          resolve(result);
        } else {
          reject('Invalidate response');
        }
      }).catch((error) => {
        console.error(error);
        reject(error);
      });
  })
};

/** 軸受特徴周波数自動設定　リスト件数確認 */
const GethandleBearingFeaturesFreqValidate = (data: JudgeSettingItemModel) => {
  if (data == undefined) return false;
  return true;
};

/**
 * 側帯波周波数自動設定　一覧取得
 * @param plcNo
 * @param aiNo
 * @param chNo
 * @returns
 */
export const GetSideBandFreqItems = (plcNo: number, aiNo: number, chNo: number): Promise<JudgeSettingItemModel> => {

  const url = `api/JudgeSetting/sideBandFreqItems/${plcNo}/${aiNo}/${chNo}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: JudgeSettingItemModel) => {
        if (SideBandFreqValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

/** 側帯波周波数自動設定　リスト件数確認 */
const SideBandFreqValidate = (data: JudgeSettingItemModel) => {
  //console.debug(`JudgeSetting ckeck ${data}`);
  if (data == undefined) return false;
  //console.debug("JudgeSetting ckeck ok");
  return true;
};

/**
 * 自動設定の値を設定
 * @param targetData
 * @param autoSettings
 * @param plcCol
 * @returns
 */
export const SetJusgeAutoSetting = (targetData: JudgeSettingItem, autoSettings: JudgeAutoSettingItem[], plcCol: PLCcollectSettingType)
  : { WRN_LIM: number | null, ALM_LIM: number | null } => {

  let ret: { WRN_LIM: number | null, ALM_LIM: number | null } = { WRN_LIM: null, ALM_LIM: null }

  console.debug(["targetData,autoSettings,plcCol", targetData, autoSettings, plcCol]);
  let f1 = autoSettings.filter((r) => String(r.KindNameNo) == plcCol.MeasureKindNo);
  let f2 = f1.filter((r) => r.JogTypeNo == targetData.JDG_TYP);
  let f3 = f2.filter((r) => r.ClcTypeNo == targetData.CLC_TYP);
  let f4 = f3.filter((r) => r.AlmKindTypeNo == targetData.MCLC_TYP_ID);
  console.debug(["f1,f2,f3,f4", f1, f2, f3, f4]);
  if (f4.length !== 0) {
    for (let i = 0; i < f4.length; i++) {
      const r = f4[i];
      if (r.RatedSpeedUseFlg) {
        if (r.RatedSpeed >= plcCol.RatedSpeed) {
          console.debug(["r.RatedSpeed >= plcCol.RatedSpeed", r.RatedSpeed, plcCol.RatedSpeed]);
          ret = { WRN_LIM: Number(r.WrnLim), ALM_LIM: Number(r.AlmLim) };
          break;
        }
      }
      else {
        ret = { WRN_LIM: Number(r.WrnLim), ALM_LIM: Number(r.AlmLim) };
        break;
      }
    }
    console.debug(["autoValue - WRN_LIM , ALM_LIM", ret]);
  }
  return ret;
}


/**
 * 軸受特徴周波数自動設定ボタン有効チェック
 */
export const IsBearingFeaturesFreqButton = (targetData: PLCcollectSettingType): boolean => {
  if (targetData.Speed == SpeedKind.SPEED_KIND_HIGHT && targetData.MeasureKindNo == MeasureHighKind.VIBRATION.toString()) {
    return true;
  }
  if (IsConanAirPlc(targetData.PLCNo)) {
    return true;
  }
  return false;
}
/**
 *側帯波周波数自動設定ボタン有効チェック
 */
export const IsSideBandFreqItemButton = (targetData: PLCcollectSettingType): boolean => {
  if (targetData.Speed == SpeedKind.SPEED_KIND_HIGHT) {
    if (targetData.MeasureKindNo == MeasureHighKind.R_CURRENT.toString() ||
      targetData.MeasureKindNo == MeasureHighKind.S_CURRENT.toString() ||
      targetData.MeasureKindNo == MeasureHighKind.T_CURRENT.toString()) {
      return true;
    }
  }
  else if (targetData.Speed == SpeedKind.SPEED_KIND_HIGHT) {
    if (targetData.MeasureKindNo == MeasureCalcKind.ZERO_CURRENT.toString() ||
      targetData.MeasureKindNo == MeasureCalcKind.SEI_CURRENT.toString() ||
      targetData.MeasureKindNo == MeasureCalcKind.GYAKU_CURRENT.toString()) {
      return true;
    }
  }

  return false;
}

/**
 * ColDataを元に自分のデータの判定設定で使用する選択項目の情報を返す。
 */
export const GetJudgeSelectItemInfo = (
  selectList: JudgeSettingSelectType[],
  colData: PLCcollectSettingType
): JudgeSettingSelectType[] => {
  //KindNoNameSet のSpeedとNameNoが一致するデータ

  if (IsConanAirPlc(colData.PLCNo)) {
    return selectList.filter((r) => r.SPEED == colData.Speed);
  } else {
    return selectList.filter((r) => r.SPEED == colData.Speed && r.NAME_NO.toString() == colData.MeasureKindNo);
  }
};
